import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux'
import { createStore, applyMiddleware, compose, combineReducers, type AnyAction } from 'redux'
import thunk, { type ThunkDispatch } from 'redux-thunk'

import * as actionCreators from '../../components/Checkout/checkoutFunctions'
import reducers from '../../reducers'
import slices from './slices'
import type { PortalPagesSlice } from './slices/slice.portalPages/portalPages.types'

const middleware = [thunk]

const devOptions = {
  trace: true,
  actionCreators
}

const prodOptions = {
  trace: false
}

const options = process.env.NODE_ENV === 'production' ? prodOptions : devOptions

const composeEnhancers =
  typeof window === 'object' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ ...options })
    : compose

const store = createStore(combineReducers({ ...reducers, ...slices }), {}, composeEnhancers(applyMiddleware(...middleware)))

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>
export type AppSelector = TypedUseSelectorHook<RootState>

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>()
export const useAppSelector: AppSelector = useSelector

export { store }
